﻿import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";

/* Import model */
import { AuthData, AuthDataV2 } from "../../../model/authentication/auth.data";
import { AuthenticationService } from "../../../service/api/auth/auth.service";

@Component({
    selector: "bo-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"]
})

export class LoginComponent implements OnInit {

  constructor(
      private AuthService: AuthenticationService,
      private localStorageService: LocalStorageService,
      private router: Router
  ) { }

  auth_data: AuthDataV2 = new AuthDataV2();
  username: string = "";
  password: string = "";
  tempUrl: string = "";

  _userEmail: string = "";
  _userSurrKey: number = 0;
  _companySurrKey: number = 0;

  sub: any;

  // Validate Data
  isEmail: boolean = true;

  ngOnInit(): void {

      // Check token and redirect to Home
    //   if (this.localStorageService.get("accessToken")) {
    //       this.router.navigate(["/jubili/company"]);
    //   }
  }

  onLoggedin(): void {

      if (this.username === "" || this.password === "") {
          this.isEmail = false;
      } else {
          this.isEmail = true;
          this.Login(this.username, this.password);
      }
  }

  onLogout(): void {
      const access = this.localStorageService.get<string>("accessToken");
      const refresh = this.localStorageService.get<string>("refreshToken");
      this.AuthService.logout(access);
      this.router.navigate(["/"]);
  }

  Login(username: string, password: string): void {

      this.AuthService.login(username, password)
        .subscribe(
          response => {
              console.log(response);
              console.log(this.localStorageService);
              this.auth_data = response;
              // Storage Session
              this.localStorageService.set("userEmail", this.username);
              this.localStorageService.set("accessToken", this.auth_data.authenticationResult.accessToken);
              this.localStorageService.set("refreshToken", this.auth_data.authenticationResult.refreshToken);
              this.localStorageService.set("expiresTime", (Date.now() / 1000) + this.auth_data.authenticationResult.expiresIn);
              console.log(this.localStorageService.get("userEmail"));

              this.router.navigate(["/home"]);
              

          }, error => {
                console.log(error);
          }
      );

  }

}
